import { render, staticRenderFns } from "./GroupUser.vue?vue&type=template&id=7ec6052d"
import script from "./GroupUser.vue?vue&type=script&lang=js"
export * from "./GroupUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports